import 'core-js/modules/es.object.assign.js';
import { jsx } from 'react/jsx-runtime';
import { Button, withUtility, spacing, Stack } from '@hub-la/design-system';
import ArrowDropDownOutlined from '@mui/icons-material/ArrowDropDownOutlined';
import { styled } from '@mui/material/styles';
import { UserAvatar } from './user-avatar.js';

let _ = t => t,
  _t;
const Trigger = styled(Button)(_t || (_t = _`
  background-color: ${0};
  border-radius: ${0};
  padding: ${0};
  border-width: 0;
  .MuiButton-endIcon {
    margin-left: 2px;
  }
  :hover {
    background-color: ${0};
  }
`), withUtility(({
  palette,
  isLight
}) => palette(isLight ? 'surfaceAt1' : 'surface')), spacing(10), spacing(1, 3, 1, 2), withUtility(({
  palette,
  isLight
}) => palette(isLight ? 'surfaceAt3' : 'surfaceAt2')));
const DropdownButton = props => {
  return jsx(Stack, {
    children: jsx(Trigger, Object.assign({
      hierarchy: "secondary",
      variant: "filled",
      endIcon: jsx(ArrowDropDownOutlined, {})
    }, {
      children: jsx(UserAvatar, {
        src: props.picture,
        variant: "circular",
        width: "32px",
        height: "32px"
      })
    }))
  });
};

export { DropdownButton };
